import {
  CENTERPANO_ZOOM_MIN_MAX,
  EXTERIOR360_ZOOM_MIN_MAX,
  FEATURE_SHOT_ZOOM_MIN_MAX,
  INTERIOR360_ZOOM_MIN_MAX,
  THUMBNAILS_ZOOM_MIN_MAX,
} from '~/env';

export const calculateZoom = (minZoom: number, maxZoom: number, zoom: number, delta: number) => {
  const newZoom = zoom * (0.999 ** delta);
  return Math.max(Math.min(newZoom, maxZoom), minZoom);
};

const parseZoomConfig = (config: string) => {
  const values = config.split('|');
  return {
    minZoom: parseInt(values[0], 10) / 100,
    maxZoom: parseInt(values[1], 10) / 100,
  };
}

export const ZOOM_CONFIG: Record<string, { minZoom: number; maxZoom: number }> = {
  shot: parseZoomConfig(FEATURE_SHOT_ZOOM_MIN_MAX),
  'E360': parseZoomConfig(EXTERIOR360_ZOOM_MIN_MAX),
  'I360': parseZoomConfig(INTERIOR360_ZOOM_MIN_MAX),
  pano: parseZoomConfig(CENTERPANO_ZOOM_MIN_MAX),
  thumbnails: parseZoomConfig(THUMBNAILS_ZOOM_MIN_MAX),
}
